import styled from 'styled-components';

export const RouteManagementContainerStyle = styled.div`
  .download-action-buttons {
    margin-top: -2%
  }
  .generated-list__table-wrapper {
    min-height: 740px;
  }
`;
